import { render, staticRenderFns } from "./VCardActionsWrapper.vue?vue&type=template&id=66dfd4ca"
import script from "./VCardActionsWrapper.vue?vue&type=script&lang=js"
export * from "./VCardActionsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports